import { useEffect, useRef, useState } from "react";

import { db } from "../../../firebase/firestore";
import {
  collection,
  onSnapshot,
  query,
  orderBy
} from "firebase/firestore";

function toMillis(value) {
  if (!value) return 0;
  if (typeof value?.toDate === "function") {
    return value.toDate().getTime();
  }
  if (Number.isFinite(value?.seconds)) {
    return Number(value.seconds) * 1000;
  }
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatCreatedAt(value) {
  const ms = toMillis(value);
  if (!ms) return "N/A";
  return new Date(ms).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState("all");
  const prevCountRef = useRef(0);

  // 🔊 SOUND
  const playSound = () => {
    try {
      const audio = new Audio("/notification.mp3");
      audio.play().catch(() => {});
    } catch {
      // no-op if browser blocks autoplay
    }
  };

  // 🔥 REAL-TIME LISTENER
  useEffect(() => {
    const q = query(collection(db, "orders"), orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(q, (snap) => {
      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        seen: false
      }));

      // 🔔 Play sound if new order count grows
      if (data.length > prevCountRef.current) {
        playSound();
      }

      prevCountRef.current = data.length;

      setNotifications(data);
    });

    return () => unsubscribe();
  }, []);

  // 🔥 MARK AS READ
  const markAsRead = (id) => {
    setNotifications(prev =>
      prev.map(n =>
        n.id === id ? { ...n, seen: true } : n
      )
    );
  };

  // 🔥 FILTER
  const filtered = notifications.filter(n => {
    if (filter === "all") return true;
    if (filter === "unread") return !n.seen;
    return true;
  });

  return (
    <div className="notifications-page">

      <h1>🔔 Notifications</h1>

      {/* 🔥 FILTER */}
      <div className="filters">
        <button onClick={() => setFilter("all")}>All</button>
        <button onClick={() => setFilter("unread")}>
          Unread ({notifications.filter(n => !n.seen).length})
        </button>
      </div>

      {/* 🔥 LIST */}
      <div className="notif-list">

        {filtered.length === 0 ? (
          <p>No notifications</p>
        ) : (
          filtered.map(n => (
            <div
              key={n.id}
              className={`notif-card ${n.seen ? "" : "new"}`}
            >

              <div className="notif-main">
                <h3>📦 New Order</h3>
                <p>₹{n.total}</p>
                <p>Status: {n.status}</p>

                <small>
                  {formatCreatedAt(n.createdAt || n.createdAtMs)}
                </small>
              </div>

              <div className="actions">
                {!n.seen && (
                  <button onClick={() => markAsRead(n.id)}>
                    Mark Read
                  </button>
                )}
              </div>

            </div>
          ))
        )}

      </div>

    </div>
  );
}